import type {
  GenerateUploadUrl,
  UploadedFileValue
} from "../form/FileUploadInput/FileUploadInput.types";

/**
 * Uploads one file through a signed slot: asks the injected endpoint for the
 * slot, PUTs the bytes to it, and returns the object path to submit as the
 * stored value. The endpoint is injected because it differs between
 * authenticated users and share-link guests.
 */
export const uploadToSignedSlot = async (
  file: File,
  generateUpload: GenerateUploadUrl
): Promise<UploadedFileValue> => {
  const slot = await generateUpload(file.name);

  const upload = await fetch(slot.upload_url, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type || "application/octet-stream" }
  });
  if (!upload.ok) {
    throw new Error(`Upload failed: ${upload.statusText}`);
  }

  return { path: slot.path, filename: file.name };
};
